<template lang="pug">
  v-row( justify="space-between" no-gutters)
    v-col(style="order:1;")
      v-row(no-gutters)
        v-col(
          v-for="(modeItem,iM) in modeList"
          :key="iM" cols="auto" 
          :style="{ order: iM+1 }"
        ).pt-3
          n2-btn(
            roundTop
            :style="shadowStyle(modeItem)"
            :color="mode === modeItem.value ? 'white' : 'var(--btn-grey-2-v2)'"
            @click="mode = modeItem.value"
          ).buttonTab
            v-img(
              :src="mode !== modeItem.value ? modeItem.iconWhite : modeItem.iconGrey"
              max-width="20"
            )
            component(
              :is="mode === modeItem.value ? 'h5' : 'h5'"
              :class="mode === modeItem.value ? 'black--text' : ''"
            ).textTab {{ $t(modeItem.name) }} 
    v-col(align="end" cols=12 sm="auto").buttonBack.pt-3
      slot
</template>
<script>
const TAB_ORDER = () => 1
const TAB_LAST_WINNUMBER = () => 2
export default {
  props: {
    value: {
      type: Number,
      default: 1
    }
  },
  data: () => ({
    mode:0,
    modeList:[
      { 
        name:'button.power-ball-order',
        value: TAB_ORDER(),
        icon: 'mdi-file-document',
        iconWhite: require('@/assets/powerball/icon-list-white.svg'),
        iconGrey:require('@/assets/powerball/icon-list-grey.svg')
      },
      { 
        name:'button.power-ball-last-winnumber',
        value: TAB_LAST_WINNUMBER(),
        icon: 'mdi-clock',
        iconWhite: require('@/assets/powerball/icon-clock-white.svg'),
        iconGrey: require('@/assets/powerball/icon-clock-grey.svg')
      },
    ]
  }), 
  watch: {
    value (val) {
      this.mode = val
    },
    mode (val) {
      this.$emit('input',val)
    }
  },
  mounted () {
    this.mode = this.value
  },
  methods: {
    shadowStyle (modeItem) {
      const selectNumberMode = TAB_ORDER()
      const pushNumberMode = TAB_LAST_WINNUMBER()
      return modeItem.value === selectNumberMode && this.mode === selectNumberMode 
      ? 'z-index:5; box-shadow:3px 0px rgba(0, 0, 0, 0.2) !important;' 
      : modeItem.value === pushNumberMode && this.mode === pushNumberMode 
      ? 'z-index:5; box-shadow:-3px 0px rgba(0, 0, 0, 0.2) !important' 
      : ''
    }
  }
}
</script>
<style scoped>
@media only screen and (max-width: 600px) {
  .buttonTab {
    min-width: 0 !important;
  }
  .buttonBack {
    width: 100%;
    order: 0 !important;
  }
  .textTab {
    font-size: 8px  !important;
  }
}
.buttonBack {
  order: 3;
}
</style>